import { useEffect, useState } from "react";
import { noop } from "lodash";
import { useRecoilValue } from "recoil";
import { typeformScriptLoadedState } from "../states/TypeformStates";

const useTypeForm = (id) => {
  const [typeform, setTypeform] = useState({
    open: noop,
    clone: noop,
    toggle: noop,
    refresh: noop,
  });

  const typeformLoaded = useRecoilValue(typeformScriptLoadedState);

  useEffect(() => {
    if (typeformLoaded) {
      setTypeform(window.tf.createPopup(id));
    }
  }, [id, typeformLoaded]);

  return typeform;
};

export default useTypeForm;
